import Vue from 'vue'
import Vuex from 'vuex'
import { alert } from './modules/alert'
import { authentication } from './modules/authentication'
import { navigationDrawer } from './modules/navigationDrawer'
import { newContactDialog } from './modules/newContactDialog'
import { contact } from './modules/contact'
import { account } from './modules/account'
import { group } from './modules/group'
import { category } from './modules/category'
import { interest } from './modules/interest'
import { polling } from './modules/polling'
import { workHistory } from './modules/workHistory'
import { messageDrawer } from './modules/messageDrawer'
import { toolBar } from './modules/toolBar'
import { message } from './modules/message'
import { socketIO } from './modules/socketIO'
import { automation } from './modules/automation'
import { metLocation } from './modules/metLocation'
import createPersistedState from 'vuex-persistedstate'
import * as Cookies from 'js-cookie'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'
const persistedStateMutationWhiteList =
  [ 'authentication/restTokenAuth',
    'authentication/tokenRefresh',
    'authentication/chatRestTokenAuth',
    'authentication/tokenAuth',
    'authentication/chatLoginSuccess',
    'authentication/loginSuccess',
    'authentication/loginFailure',
    'authentication/logoutSuccess',
    'authentication/logoutFailure']

export default new Vuex.Store({
  strict: debug,
  modules: {
    alert,
    authentication,
    navigationDrawer,
    newContactDialog,
    contact,
    group,
    category,
    interest,
    polling,
    account,
    workHistory,
    messageDrawer,
    toolBar,
    message,
    socketIO,
    automation,
    metLocation
  },
  plugins: [createPersistedState({
    storage: {
      getItem: key => Cookies.get(key),
      setItem: (key, value) =>
        Cookies.set(key, value, { expires: 3, secure: false }),
      removeItem: key => Cookies.remove(key)
    },
    reducer: (state) => ({ authentication: state.authentication }),
    filter: mutation => (persistedStateMutationWhiteList.includes(mutation.type))
  })]
})
